// Generated by Melange

import * as Caml_option from "melange.js/caml_option.js";
import * as Stdlib__Float from "melange/float.js";
import * as Stdlib__String from "melange/string.js";

function parse(text) {
  if (Stdlib__String.trim(text) === "") {
    return Caml_option.some(undefined);
  }
  const date = new Date(text);
  const value = date.getTime();
  const now = Date.now();
  if (text.length === 24 && Stdlib__Float.is_finite(value) && date.toISOString() === text && value > now && value <= now + 43200000) {
    return Caml_option.some(value);
  }
  
}

export {
  parse,
}
/* Stdlib__Float Not a pure module */
